module.exports = __webpack_public_path__ + "static/img/play@80x80.0052e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/play@80x80.png
// module id = 641
// module chunks = 2